import { Modal } from '../components/Modal';
import type { Notification } from '../state';

type Props = {
    items: Notification[];
    onClose: () => void;
    onDelete: (id: number) => void;
    onAction: (n: Notification) => void;
};

export function NotificationsModal({ items, onClose, onDelete, onAction }: Props) {
    return (
        <Modal title="Уведомления" onClose={onClose}>
            {items.length === 0 ? (
                <div className="text-center text-muted f-12" style={{ padding: 20 }}>
                    Нет новых уведомлений.
                </div>
            ) : (
                items.map((n) => (
                    <div key={n.id} className="info-card" style={{ position: 'relative' }}>
                        <button
                            type="button"
                            className="task-close"
                            aria-label="Удалить"
                            onClick={() => onDelete(n.id)}
                        >
                            ✕
                        </button>
                        <p className="popup-text" style={{ paddingRight: 20 }}>
                            {n.text}
                        </p>
                        {n.actionLabel && (
                            <button
                                type="button"
                                className={`action-btn btn-${
                                    n.accent === 'gold'
                                        ? 'outline-gold'
                                        : n.accent === 'green'
                                          ? 'green'
                                          : n.accent === 'red'
                                            ? 'red'
                                            : 'blue'
                                }`}
                                onClick={() => onAction(n)}
                            >
                                {n.actionLabel}
                            </button>
                        )}
                    </div>
                ))
            )}
        </Modal>
    );
}
